import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Typography } from '@mui/material';
import { ScreenFrame } from '../PrototypeShared';

export default function StockScreen() {
  return (
    <ScreenFrame
      title="Stock management"
      actions={
        <>
          <Button component={Link} to="/prototype/incoming-deliveries/stock" variant="outlined" size="small">Incoming stock</Button>
          <Button component={Link} to="/prototype/pallets" variant="outlined" size="small">Pallets</Button>
        </>
      }
    >
      <Typography color="text.secondary" paragraph>Move stock, view by location. Links to incoming stock and pallets.</Typography>
      <Button component={Link} to="/prototype/operator" variant="contained">Operator home</Button>
    </ScreenFrame>
  );
}
